module.exports = __webpack_public_path__ + "img/IS.56b1e2ce.svg";